import { User } from "~/types/User";
import RestResource from "../rest/RestResource";

import AuthStorage from "./storage";
import { email } from "@vuelidate/validators";
import Cache from "../cache/Cache";

export class Auth extends RestResource {
  // Auth Module Options
  private readonly router: any;
  private readonly registerData = { method: "POST" };
  private readonly logoutData = { redirect: "/" };
  private readonly authRedirect = { name: "login" };
  private readonly notFoundRedirect = { name: "dashboard" };

  private static readonly storage = AuthStorage;

  protected static user: User | null = null;

  // RestResource Options
  protected static basePath = "/auth";

  constructor() {
    super(); // No hace nada, pero es necesario para que no de error

    this.router = useRouter();

    setInterval(this.refresh, 60 * 5 * 1000); // 5 minutos
    this.refresh();
  }

  ready() {
    return true;
  }

  redirect() {
    this.router.push(this.authRedirect);
  }

  async refresh() {
    if (!Auth.storage.token || !Auth.storage.isExpired) return false;
    Auth.fetch(`${Auth.ApiWrite}/refresh`, {
      method: "POST",
    }).then(({ data, error }: any) => {
      if (!data) return;
      if (error.value) {
        if (!String(error.value).includes("The user aborted a request")) {
          return this.redirect();
        }

        return Auth.storage.deleteToken();
      }

      // @ts-ignore
      const { token, expires_in } = data;
      Auth.storage.setToken(token, expires_in);
    });
  }

  async login(email: string, password: string) {
    Auth.user = null;

    Auth.fetch(`${Auth.ApiWrite}/login`, {
      method: "POST",
      body: JSON.stringify({ email, password }),
    }).then(({ data, error }: any) => {
      if (!data) return;
      if (error.value) return this.redirect();

      Cache.deleteUserProfilePicture();

      // @ts-ignore
      const { token, expires_in } = data;
      Auth.storage.setToken(token, expires_in);
    });
  }

  check() {
    return Auth.storage.check();
  }

  logout() {
    Auth.storage.deleteToken();
    Cache.deleteUserProfilePicture();
    this.router.push(this.logoutData);
  }

  async user() {
    if (Auth.user) return Auth.user;

    return await Auth.fetch(`${Auth.ApiWrite}/user`, { method: "GET" }).then(
      ({ data, success }: any): User | null => {
        if (!data || !success) return null;

        // @ts-ignore
        const { user } = data;
        Auth.user = user as User;
        return user as User;
      }
    );

  }
}
